export const buildEisfAccessBody = (values) => {
  if (!values?.grantEisfAccess) {
    return {};
  }

  const body = { grantEisfAccess: true };

  if (values.studyId && values.countryId) {
    body.eisfAccess = {
      studyId: values.studyId,
      countryId: values.countryId,
    };
  }

  return body;
};

export const buildResearchSiteConnectBody = (values, recipientId) => {
  const { note } = values;

  return {
    note,
    recipientId,
    ...buildEisfAccessBody(values),
  };
};

export const buildAcceptConnectionBody = (values) =>
  buildEisfAccessBody(values);
